angular.
module("digiexam.components").
directive("questionDroppable", function questionDroppableDirective() {
	"use strict";

	return {
		restrict: "A",

		link: function link($scope, element) {
			return element.droppable({
				accept: ".library_question",
				over: function over(event, ui) {
					ui.helper.addClass("over");
					return element.addClass("class-hovering");
				},
				out: function out(event, ui) {
					ui.helper.removeClass("over");
					return element.removeClass("class-hovering");
				},
				drop: function drop(event, ui) {
					element.removeClass("class-hovering");

					return $scope.exam.copyQuestion(ui.helper.data("question"));
				},
			});
		},
	};
});
